import { A } from '../actions/modal';
import update from 'immutability-helper';

const initialState = {
  show: false,
  type: null,
  data: null,
  shouldRefresh: false,
};

const modal = (state = initialState, action) => {
  switch (action.type) {
    case A.SHOW_MODAL:
      return update(state, {
        show: { $set: true },
        type: { $set: action.modalType },
        data: { $set: action.data },
        shouldRefresh: { $set: false },
      });

    case A.HIDE_MODAL:
      return update(state, {
        show: { $set: false },
        type: { $set: null },
        data: { $set: null },
      });

    case A.REFRESH_MODAL:
      return update(state, {
        shouldRefresh: { $set: state.type },
        show: { $set: false },
        type: { $set: null },
        data: { $set: action.data },
      });

    default:
      return state;
  }
};

export default modal;
